export enum PromotionRequirementTypeEnum {
  MinimumCartValue = 'minimumCartValue',
  MaximumCartValue = 'maximumCartValue',
  MinimumItemValue = 'minimumItemValue',
  MaximumItemValue = 'maximumItemValue',
  MinimumItemsAmount = 'minimumItemsAmount',
  MaximumItemsAmount = 'maximumItemsAmount'
}
